<template>
  <v-container grid-list-sm text-left fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-alert :value="true" color="grey lighten-3" class="black--text mt-3 text-xs-center" v-for="(invite, index) in invites" :key="index">
          <p>{{invite.text}}</p>
          <v-btn class="error" @click="acceptInvite(index, false)">Отклонить</v-btn>
          <v-btn class="success" @click="acceptInvite(index, true)">Принять</v-btn>
        </v-alert>
      </v-flex>
      
      <v-flex xs12 md6>
        <div style="position: relative;" class="pb-4">
          <span class="headline">Мои компании</span>
          <v-btn color="secondary" icon absolute right @click="dialog = true" title="Создать компанию">
            <v-icon>add</v-icon>
          </v-btn>
        </div>
        <!-- <v-divider /> -->
        <v-card flat>
          <v-list>
            <template v-if="companies && companies.length">
              <draggable v-model="companies" @end="endSorting">
                <v-list-tile v-for="(company, index) in companies" avatar @click="editCompany(index)" :key="index">
                  <v-list-tile-content>
                    <v-list-tile-title>{{company.name}}</v-list-tile-title>
                    <v-list-tile-sub-title>{{company.description}}</v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-tooltip top>
                      <v-btn icon dark color="secondary" slot="activator" :to="getRouteData({ name: 'org.hierarchy', params: { cid: company.id } })">
                        <v-icon>exit_to_app</v-icon>
                      </v-btn>
                      <span>Перейти в группу</span>
                    </v-tooltip>
                  </v-list-tile-action>
                </v-list-tile>
              </draggable>
            </template>
            <template v-else>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>Список компаний пуст</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
          <!-- <p v-else>No any companies created yet.</p> -->
        </v-card>
      </v-flex>
      
      <v-flex xs12 md6>
        <v-card flat class="pa-2" v-show="show_panel">
          <h2 class="title">{{current_company.name}}</h2>
          <v-select
            :items="current_posts"
            label="Пост по умолчанию"
            item-text="name"
            item-value="id"
            hint="Переход в компанию будет осуществляться на выбранный пост"
            persistent-hint
            v-model="default_post"
            no-data-text="Нет доступных постов для выбора"></v-select>
          
          <v-select
            :items="order_numbers"
            label="Позиция в списке компаний"
            hint="Данная компания будет отображаться по выбранному порядковому номеру"
            persistent-hint
            v-model="company_number"
            no-data-text="Отсутствуют"></v-select>
          
          <v-checkbox
            v-model="default_company"
            class="pt-2" 
            label="Сделать компанией по умолчанию"
            hint="Автоматический вход в данную компанию после аутентификации"
            persistent-hint
          ></v-checkbox>
          
          <v-btn color="success" dark class="mt-3" @click="saveCompany">Сохранить</v-btn>
          <v-btn color="error" flat class="pull-right mt-3" @click="deleteCompany">Удалить компанию</v-btn>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="dialog" max-width="500">
      <new-company-form v-if="dialog" @close-dialog="dialog=false" @save="addCompany"></new-company-form>
    </v-dialog>
  </v-container>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import draggable from 'vuedraggable'
import apiAccount from "../../api"
import NewCompanyForm from './Forms/NewCompanyForm'

export default {
  name: 'MyCompanies',
  
  components:{
    NewCompanyForm,
    draggable
  },
  
  data() {
    return {
      current_company: {},
      current_posts: [],
      company_number: 0,
      default_post: false,
      default_company: false,
      order_numbers: [],
      show_panel: false,
      invites: [],
      companies: [],
      dialog: false,
    }
  },
  
  computed: {
    ...mapGetters('app/layout', ['getRouteData']),
  },
  
  mounted() {
    this.loadCompanies().then( response => {
      this.companies = response
    })
    this.getInvites()
  },
  
  methods: {
    ...mapActions('app/account', ['loadCompanies']),

    getInvites(){
      apiAccount.invites().then( response => {
        this.invites = response.invites
      })
    },

    addCompany(eventData){
      this.companies.unshift(eventData)
      this.$store.commit(`app/account/setCompanies`, this.companies)
      this.dialog = false
    },
    
    editCompany(index){
      this.order_numbers = []
      
      this.current_company = {...this.companies[index]}
      this.current_posts = this.current_company.posts
      this.default_company = this.current_company.default
      
      this.company_number = index+1
      for(let post of this.current_posts){
        if (post.is_default===true) this.default_post = post.id
      }
      for(let i=1, len = this.companies.length; i<=len; i++) this.order_numbers.push(i)
      this.show_panel = true
    },
    
    saveCompany(){
      for(let i=0, len = this.companies.length; i<len; i++){
        if (this.default_company) this.companies[i].default = false
        
        if(this.companies[i].id === this.current_company.id){
          this.companies[i].default = this.default_company
          
          this.companies[i].posts.map(post => {
            post.is_default = post.id === this.default_post
          })
          
          if(i!==this.company_number-1){
            let temp = this.companies[i]
            this.companies[i] = this.companies[this.company_number-1]
            this.companies[this.company_number-1] = temp
          }
          if(this.default_post){
            this.$store.dispatch('account/saveDefaultPost', {company_id: this.companies[i].id, post_id: this.default_post}).then( response => {
              this.$store.commit(`app/account/setCompanies`, this.companies)
            })
          }
          if(this.default_company){
            this.$store.dispatch('account/saveDefaultCompany', this.companies[i].id).then( response => {
              this.$store.commit(`app/account/setCompanies`, this.companies)
            })
          } else {
            this.$store.dispatch('account/deleteDefaultCompany', this.companies[i].id).then( response => {
              this.$store.commit(`app/account/setCompanies`, this.companies)
            })
          }
          this.clearData()
          this.$forceUpdate()
        }
      }
    },
  
    deleteCompany(){
      this.$dmsAgree('Вы уверены, что хотите удалить группу?').then( _ => {
        this.$store.dispatch('app/org/deleteCompany', this.current_company.id).then( response => {
          this.loadCompanies()
          this.clearData()
        })
      })
    },
    
    clearData(){
      this.current_company = {}
      this.current_posts = []
      this.company_number = 0
      this.default_post = false
      this.order_numbers = []
      this.show_panel = false
    },

    acceptInvite(index, accept){
      let invite_id = this.invites[index].id
      apiAccount.acceptInvite({ invite_id:invite_id, accept: accept }).then( response => {
        if (accept) {
          this.loadCompanies()
        }
        this.invites.splice(index, 1)
      })
    },
  
    endSorting({newIndex, oldIndex}){
      if(newIndex!==oldIndex){
        let node = null, target = null, mode = null;
        if(newIndex===0){
          node = this.companies[newIndex].id
          target = this.companies[newIndex+1].id
          mode = 'before'
        } else {
          node = this.companies[newIndex].id
          target = this.companies[newIndex-1].id
          mode = 'after'
        }
        this.$store.dispatch('account/changeCompanyPosition', {node, target, mode}).then( response => {
          this.$store.commit(`app/account/setCompanies`, this.companies)
        })
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/apps/account/components/Account/MyCompanies.vue